/* import __COLOCATED_TEMPLATE__ from './sections.hbs'; */
import Component from "@glimmer/component";
import { service } from "@ember/service";

export default class SidebarAnonymousSections extends Component {
  @service siteSettings;
}
